import { Box, Button, makeStyles, Theme, colors } from "@material-ui/core";
import { ArrowDropDown, Delete } from "@material-ui/icons";
import { ButtonType } from "./types";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import clsx from "clsx";
import * as React from "react";

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    border: "1px solid rgba(151,151,151, 0.5)",
    textTransform: "capitalize",
    height: 40,
    maxWidth: 180,

    "& svg, & path": {
      fill: "#3F51B5",
    },
  },
  buttonLabel: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "block",
    whiteSpace: "nowrap",
  },
  padRight: {
    paddingRight: theme.spacing(2),
  },
  errorButton: {
    "& svg, & path": {
      fill: theme.palette.error.main,
    },
    color: theme.palette.error.main,
    border: `1px solid ${alpha(theme.palette.error.main, 0.5)}`,
    "&:hover": {
      border: `1px solid ${theme.palette.error.main}`,
      backgroundColor: alpha(
        theme.palette.error.main,
        theme.palette.action.hoverOpacity
      ),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
  },
  successButton: {
    "& svg, & path": {
      fill: theme.palette.success.main,
    },
    color: theme.palette.success.main,
    border: `1px solid ${alpha(theme.palette.success.main, 0.5)}`,
    "&:hover": {
      border: `1px solid ${theme.palette.success.main}`,
      backgroundColor: alpha(
        theme.palette.success.main,
        theme.palette.action.hoverOpacity
      ),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
  },
}));

interface MenuButtonProps {
  menuID: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  label: string;
  showArrow?: boolean;
  startIcon?: React.ReactNode;
  type?: ButtonType;
}

export default React.forwardRef(function MenuButton(
  {
    menuID,
    onClick,
    label,
    showArrow = true,
    type = ButtonType.Info,
    startIcon,
  }: MenuButtonProps,
  forwardRef
) {
  const classes = useStyles();

  let clss = classes.button;

  switch (type) {
    case ButtonType.Info:
      clss = classes.button;
      break;
    case ButtonType.Error:
      clss = classes.errorButton;
      break;
    case ButtonType.Success:
      clss = classes.successButton;
      break;
  }

  return (
    <Button
      ref={forwardRef as any}
      aria-controls={menuID}
      aria-haspopup="true"
      onClick={onClick}
      className={clsx(clss)}
      title={label}
      startIcon={startIcon}
    >
      <Box
        component="span"
        className={clsx(classes.buttonLabel, showArrow && classes.padRight)}
      >
        {label}
      </Box>
      {showArrow && <ArrowDropDown />}
    </Button>
  );
});
